(() => {
  const selector = '[data-p01-flip-card]';
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function mount(card) {
    if (card.dataset.p01FlipReady) return;
    const toggle = card.querySelector('[data-p01-flip-toggle]');
    const label = card.querySelector('[data-p01-flip-label]');
    const front = card.querySelector('[data-p01-flip-front]');
    const back = card.querySelector('[data-p01-flip-back]');
    if (!toggle || !label || !front || !back) return;

    let hovering = false;
    let focusing = false;
    let pinned = false;
    let dismissed = false;
    let suppressFocusOpen = false;
    let open = false;

    function render() {
      open = !dismissed && (hovering || focusing || pinned);
      // The hidden face cannot receive focus or appear twice to a screen reader.
      back.inert = !open;
      back.setAttribute('aria-hidden', String(!open));
      front.inert = open;
      front.setAttribute('aria-hidden', String(open));
      card.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      label.textContent = open ? toggle.dataset.labelClose : toggle.dataset.labelOpen;
      toggle.setAttribute('aria-label', `${label.textContent}: ${toggle.dataset.cardName}`);
    }

    card.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !hover.matches) return;
      hovering = true;
      dismissed = false;
      render();
    });
    card.addEventListener('pointerleave', () => {
      hovering = false;
      dismissed = false;
      render();
    });
    card.addEventListener('focusin', (event) => {
      if (suppressFocusOpen) return;
      if (back.contains(event.target) || (event.target === toggle && toggle.matches(':focus-visible'))) {
        focusing = true;
        dismissed = false;
        render();
      }
    });
    card.addEventListener('focusout', (event) => {
      if (card.contains(event.relatedTarget)) return;
      focusing = false;
      dismissed = false;
      render();
    });
    toggle.addEventListener('click', () => {
      if (open) {
        pinned = false;
        focusing = false;
        dismissed = true;
      } else {
        pinned = true;
        dismissed = false;
      }
      render();
    });
    card.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !open) return;
      event.preventDefault();
      pinned = false;
      focusing = false;
      dismissed = true;
      suppressFocusOpen = true;
      toggle.focus({ preventScroll: true });
      suppressFocusOpen = false;
      render();
    });

    card.dataset.p01FlipReady = 'true';
    card.classList.add('is-enhanced');
    toggle.hidden = false;
    render();
  }

  function mountAll(root = document) {
    if (root.matches?.(selector)) mount(root);
    root.querySelectorAll(selector).forEach(mount);
  }
  mountAll();
  document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
})();
